<jb-modal-header [jbTitle]="compConf.title" [jbDescription]="compConf.hasDescription ? compConf.description : ''" (jbClose)="close()"></jb-modal-header>

<div class="modal-body">
  <div class="row">
    <div class="col-12">
      <p>body test</p>
    </div>
  </div>
</div>
